import React from 'react';

const landingSrc = `${process.env.PUBLIC_URL || ''}/landing/index.html`;

/**
 * Página inicial estática (build em public/landing).
 * Carrega em iframe para não misturar runtime React 19 da landing com a app principal.
 */
const LandingPage: React.FC = () => (
  <iframe
    title="Market Media"
    src={landingSrc}
    className="block w-full min-h-screen border-0"
    style={{ minHeight: '100vh' }}
  />
);

export default LandingPage;
